module.exports = __webpack_public_path__ + "static/img/introduces_footer_two.77e8848.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/introduces/introduces_footer_two.png
// module id = 1409
// module chunks = 1